import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const validateGallbladderDate = (dob: string) => {
  if (!dob) {
    return "Date of surgery is required.";
  }

  if (dob.length < 10) {
    return "Date of surgery must be at least 10 characters long.";
  }

  const date = dayjs(dob, "MM/DD/YYYY", true);
  const today = dayjs();

  if (!date.isValid() || !date.isBefore(today)) {
    return "Invalid date of surgery. It should be a valid date before today in MM/DD/YYYY format.";
  }

  const ageInYears = today.diff(date, "year", true);

  if (ageInYears < 2) {
    return "Sorry, we can't qualify patients who have undergone gallbladder removal within the last 2 years.";
  }

  return "";
};
